// This function is used to force a repaint of the page.
// It is used to ensure that the TLB is properly styled, as well as its container and wrapper.
import { isSafariBrowser } from "../../../helpers/isBrowser";

export function forceRepaintOnSafari(): void {
  // This is necessary because Safari does not repaint container with "aspect-ratio" property.
  // The delay is necessary to ensure that initially paint logic is done by the Safari.
  if (!isSafariBrowser()) return;

  // This function should be called after the skybox is put into "resolved" state.
  requestAnimationFrame(() => {
    const originalDisplay = document.body.style.display;
    document.body.style.display = "inline-block"; // Temporarily change display to trigger repaint
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    document.body.offsetHeight; // Trigger a reflow
    document.body.style.display = originalDisplay;
  });
}
